'use es6';

import LineItemRecord from 'customer-data-objects/lineItem/LineItemRecord';
import PropTypes from 'prop-types';
const LineItemRecordType = PropTypes.instanceOf(LineItemRecord);
export default LineItemRecordType;